export enum ACTION_TYPE {
    VIEW = 'VIEW',
    CLICK = 'CLICK',
    LOAD = 'LOAD',
    FILTER = 'FILTER',
    TIMER = 'TIMER',
}

export type EngagementEvent = {
    actionType?: ACTION_TYPE;
    pageUrl?: string;
    target?: string;
    type: 'Engagement' | 'Conversion';
    [key: string]: any;
};
